export const getIsWholeElementInViewport = (el: Element) => {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const getIsPartialElementInViewport = (el: Element) => {
  if (!el) return false;
  const rect = el.getBoundingClientRect();

  const vpHeight = window.innerHeight || document.documentElement.clientHeight;
  const vpWidth = window.innerWidth || document.documentElement.clientWidth;

  const isVertInView = rect.top <= vpHeight && rect.top + rect.height >= 0;
  const isHorInView = rect.left <= vpWidth && rect.left + rect.width >= 0;

  return isVertInView && isHorInView;
};
